export const FINANCE_SCREEN_DATA_URL = '/api/RiderApp/getFinanceScreenData';
export const FINANCE_PAYOUT_URL = '/api/RiderApp/getRiderPayout';
export const FINANCE_SETTINGS_URL = '/api/RiderApp/webview/settings?module=finance';

export const TASK_REVIEW_FETCH_PENDING_TASKS = '/api/RiderApp/getPendingTasks';
export const TASK_REVIEW_REJECT_PENDING_TASKS = '/api/RiderApp/task/event/reject';
export const TASK_REVIEW_ACCEPT_PENDING_TASKS = '/api/RiderApp/task/event/accept';
export const FETCH_SETTINGS = '/api/RiderApp/webview/settings';
export const REFERRALS_FETCH_ALL = '/api/RiderApp/referral/fetch';
export const REFERRALS_CREATE_NEW = '/api/RiderApp/createWorkerReferral';
export const REFERRALS_BANNER_CONFIG = '/api/RiderApp/workerreferral/overview';
export const REFERRAL_SUMMARY_METRICS = '/api/RiderApp/referral/summary';
// Joining Bonus — ISS-292770
export const JOINING_BONUS_FETCH = '/api/RiderApp/joiningbonus/fetch';

export const PARCEL_CONNECT_HUBS = '/api/RiderApp/parcelconnect/hubs';
export const CONSIGNMENT_LIST = '/api/RiderApp/parcelconnect/fetchConsignments';
export const CONSIGNMENT_UPDATE = '/api/RiderApp/parcelconnect/completeDelivery';
export const CONSIGNMENT_FETCH_AND_VALIDATE = '/api/RiderApp/consignment/v1/fetchAndValidate';
export const CREATE_PARCEL_CONNECT_PICKUP = '/api/RiderApp/parcelconnect/completePickup';
export const CREATE_FMLM_CONSIGNMENT = '/api/RiderApp/createFmlmConsignment';

export const INITIALIZE_TRIP_AUDIT = '/api/RiderApp/initializeTripAudit';
export const VALIDATE_TRIP_AUDIT_PARCEL = '/api/RiderApp/validateParcelForTripAudit';
export const COMPLETE_TRIP_AUDIT = '/api/RiderApp/completeTripAudit';

export const FETCH_WORKER_PAYOUT_OVERVIEW = '/api/RiderApp/workerpayout/overview';
export const FETCH_WORKER_PAYOUT_INCENTIVES = '/api/RiderApp/workerpayout/incentives';
export const FETCH_WORKER_PAYOUT_DETAILS = '/api/RiderApp/workerpayout/details';
export const FETCH_WORKER_PAYOUT_ORDER_BREAKDOWN = '/api/RiderApp/workerpayout/orderBreakdown';
export const FETCH_WORKER_PAYOUT_CHARGES = '/api/RiderApp/workerpayout/charges';
export const FETCH_WORKER_PAYOUT_HIGH_DEMAND_SURGES = '/api/RiderApp/workerpayout/high-demand-surges';
export const FETCH_WORKER_PAYOUT_ADHOC_SURGE_BANNER = '/api/RiderApp/workerpayout/adhocSurgeBanner';
// Conditional Min. Guarantee — ISS-293387
export const FETCH_WORKER_PAYOUT_CONDITIONAL_MIN_GUARANTEE_TOPUPS = '/api/RiderApp/workerpayout/minimum-guarantee-topups';

export const HELP_SUPPORT_SUBMIT = '/api/RiderApp/helpSupport/submit';
export const BROADCAST_TRIPS_FETCH = '/api/RiderApp/broadcast-trips/fetch';
export const BROADCAST_TRIPS_EXPRESS_INTEREST = '/api/RiderApp/broadcast-trips/express-interest';
export const BROADCAST_TRIPS_CANCEL_INTEREST = '/api/RiderApp/broadcast-trips/cancel-interest';
export const JOB_INVOICES_HISTORY = '/api/RiderApp/broadcast-trips/history';

export const SUMMARY_COUNT = '/api/RiderApp/summary/count';
export const CONSIGNMENT_SUMMARY = '/api/RiderApp/summary/consignments';

export const RAIN_MODE_FETCH_RIDER_OPEN_TICKET_COUNT = '/fetchRiderTickets';
export const RAIN_MODE_CREATE_TICKET = '/createRiderTicket';
export const RAIN_MODE_FETCH_IMAGE_PUT_URL = '/getImagePutUrl';
export const RAIN_MODE_PATCH_IMAGES = '/patchImages';

export const RAIN_MODE_V2_CREATE_TICKET = '/api/RiderApp/rain-mode/v1/ticket/create';
export const RAIN_MODE_V2_TICKET_HISTORY = '/api/RiderApp/rain-mode/v1/ticket/history';
export const LIA_UPLOAD_URL = '/api/RiderApp/incident-ticket/v1/attachment/upload-url';
export const GET_WEBVIEW_URL = '/api/RiderApp/webview/url';
export const FETCH_SHIFTS_FOR_DATE = '/api/RiderApp/getShiftsForDate';

// Gamification URLs
export const GAMIFICATION_PERFORMANCE = '/api/riderapp/gamification/performance';
export const GAMIFICATION_SUMMARY = '/api/riderapp/gamification/summary';
export const GAMIFICATION_LEADERBOARD = '/api/riderapp/gamification/leaderboard';
export const GAMIFICATION_RULE_SCORE = '/api/riderapp/gamification/ruleScore';

// Shift Preference URLs
export const FETCH_WORKER_SCHEDULE = '/api/RiderApp/getWorkerSchedule';
export const FETCH_BROADCAST_SHIFTS = '/api/RiderApp/getBroadcastShifts';
export const BOOK_CANCEL_SHIFT_PREFERENCE = '/api/RiderApp/optBroadcastShift';
export const GET_PENDING_OFFLINE_EVENTS_COUNT = '/api/RiderApp/getPendingOfflineEventsCount';

// Equipment / Asset Wallet — ISS-285582
export const EQUIPMENT_FETCH_AWAITING = '/api/RiderApp/equipment/fetchAwaiting';
export const EQUIPMENT_FETCH_ALLOCATED = '/api/RiderApp/equipment/fetchAllocated';
export const EQUIPMENT_FETCH_ELIGIBILITY = '/api/RiderApp/equipment/eligibility';
export const EQUIPMENT_GENERATE_OTP = '/api/RiderApp/equipment/generateOtp';
// Selfie Verification
export const RIDER_VERIFICATION_FETCH = '/api/RiderApp/riderVerification/fetch';

// Rider Support — ISS-285392
export const RIDER_STATE = '/api/RiderApp/riderState';
export const CLOUD_STORAGE_SIGN_READ = '/api/RiderApp/cloud-storage/generate-signed-read-url';
// Returnable Assets Reconciliation Self-Serve — ISS-288035 (v2 contract)
export const GET_RETURNABLE_ASSETS_FOR_RECONCILIATION = '/api/RiderApp/getReturnableAssetsForReconciliation';
export const DETACH_RETURNABLE_ASSETS = '/api/RiderApp/detachReturnableAssets';

export const RIDER_ACTION = {
  ONDUTY: 'onduty',
} as const;

export const FETCH_ADDRESS_NODE_LIST = '/api/RiderApp/addressNode/list';
export const FETCH_HUBS = '/api/RiderApp/hubs/fetch';
export const ASSIGN_HUB = '/api/RiderApp/hub/assign';
export const FETCH_APP_SETTINGS = '/api/RiderApp/appSettings';